import StopRoundedIcon from '@mui/icons-material/StopRounded';

export const StopTimeTrackingIcon = StopRoundedIcon;
